import React from "react";

const PrivacyRights = () => {
  return (
    <div>
      <h6 className="fw-bold mb-3">
        GDPR Rights for Candidate (if applicable)
      </h6>
      <p>
        As a candidate falling under GDPR,Indian Privacy Act,FCRA scope you
        would have the following rights:
      </p>
      <ul
        className="ps-3 mb-0"
        style={{ lineHeight: "1.9", listStyle: "disc" }}
      >
        <li>
          <b className="text-dark">The right to be informed :</b>Anyone
          processing your personal data must make clear what they are
          processing, why and who else the data may be passed on to.
        </li>
        <li>
          <b className="text-dark">The right of access :</b>this is your right
          to see what data is held about you by the data controller, which is
          Aupertz Services Private Limited.
        </li>
        <li>
          <b className="text-dark">The right to rectification :</b>this is your
          right to have the data corrected, amended if what is held is in
          correct at some point of time.
        </li>
        <li>
          <b className="text-dark">The right to erasure :</b>under certain
          circumstances you can ask for your data to be deleted. This is also
          called the “Right to be forgotten”. This would apply if the personal
          data is no longer required for the purposes it was collected for, or
          your consent for the processing of that data has been withdrawn, or
          the personal data has been unlawfully processed.
        </li>
        <li>
          <b className="text-dark">The right to restrict processing :</b>
          this gives you the right to ask for a temporary halt to processing of
          personal data, such as in the case where a dispute or legal case has
          to be concluded, or the data is being corrected.
        </li>
        <li>
          <b className="text-dark">The right to data portability :</b>
          you have the right to ask for any data supplied by you to us in any to
          be provided in a structured, commonly used and machine readable
          format.
        </li>
        <li>
          <b className="text-dark">The right to object :</b>you have the right
          to object to further processing of your data which is inconsistent
          with the primary purpose for which it was collected, including
          profiling, automation and direct marketing.
        </li>
        <li>
          <b className="text-dark">
            Rights related to automated decision making and profiling :{" "}
          </b>
          you have the right to be subject to a decision based solely on
          automated processing.
        </li>
      </ul>
    </div>
  );
};

export default PrivacyRights;
